/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxPopoverComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxpopover';

/**
 * Popover
 */
@Component({
    selector: 'ngc-popover',
    template: `<jqxPopover #jqxPopover
                [arrowOffsetValue] = "arrowOffsetValue"
                [animationOpenDelay] = "animationOpenDelay"
                [animationCloseDelay] = "animationCloseDelay"
                [autoClose] = "autoClose"
                [animationType] = "animationType"
                [initContent] = "initContent"
                [isModal] = "isModal"
                [offset] = "offset"
                [position] = "position"
                [rtl] = "rtl"
                [selector] = "selector"
                [showArrow] = "showArrow"
                [showCloseButton] = "showCloseButton"
                [title] = "title"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxPopover>`
})
export class NgcPopoverComponent extends ControlComponent {
    @Input('arrowOffsetValue') arrowOffsetValue: any;
    @Input('animationOpenDelay') animationOpenDelay: any;
    @Input('animationCloseDelay') animationCloseDelay: any;
    @Input('autoClose') autoClose: any;
    @Input('animationType') animationType: any;
    @Input('initContent') initContent: any;
    @Input('isModal') isModal: any;
    @Input('offset') offset: any;
    @Input('position') position: any;
    @Input('rtl') rtl: any;
    @Input('selector') selector: any;
    @Input('showArrow') showArrow: any;
    @Input('showCloseButton') showCloseButton: any;
    @Input('title') title: any;
    @Input('theme') theme: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    @ViewChild('jqxPopover') jqxPopover: jqxPopoverComponent;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    open() {
        this.jqxPopover.open();
    }
}

/**
 * Popover Module
 */
@NgModule({
    imports: [CommonModule],
    exports: [NgcPopoverComponent],
    declarations: [NgcPopoverComponent, jqxPopoverComponent]
})
export class NgcPopoverModule {
}